import type { InventoryListFilterView, SelectOption, SelectOptionCategorized } from "@slfinrtl/ui-bff-routes"

export const extractValues = (
	view: InventoryListFilterView,
): Record<keyof InventoryListFilterView, string[] | undefined> => {
	return {
		bodyTypes: mapSelectOptionValues(view.bodyTypes),
		dealershipIds: view.dealershipIds ? mapSelectOptionValues(view.dealershipIds) : undefined,
		derivatives: mapSelectOptionCategorizedValues(view.derivatives),
		driveTrains: mapSelectOptionValues(view.driveTrains),
		engineTypes: mapSelectOptionValues(view.engineTypes),
		equipmentTags: mapSelectOptionCategorizedValues(view.equipmentTags),
		exteriorColors: mapSelectOptionValues(view.exteriorColors),
		interiorColors: mapSelectOptionValues(view.interiorColors),
		listingVisibility: view.listingVisibility ? mapSelectOptionValues(view.listingVisibility) : undefined,
		maxFirstRegistrationDate: view.maxFirstRegistrationDate
			? mapSelectOptionValues(view.maxFirstRegistrationDate)
			: undefined,
		maxModelYear: view.maxModelYear ? mapSelectOptionValues(view.maxModelYear) : undefined,
		minFirstRegistrationDate: view.minFirstRegistrationDate
			? mapSelectOptionValues(view.minFirstRegistrationDate)
			: undefined,
		minModelYear: view.minModelYear ? mapSelectOptionValues(view.minModelYear) : undefined,
		modelGenerations: mapSelectOptionValues(view.modelGenerations),
		modelSeries: mapSelectOptionValues(view.modelSeries),
		onlineOrderableStatus: view.onlineOrderableStatus
			? mapSelectOptionValues(view.onlineOrderableStatus)
			: undefined,
		salesStatus: mapSelectOptionValues(view.salesStatus),
		stockStatus: mapSelectOptionValues(view.stockStatus),
		transmissions: mapSelectOptionValues(view.transmissions),
		vehicleTypes: mapSelectOptionValues(view.vehicleTypes),
	}
}

const mapSelectOptionValues = (values: SelectOption[]) =>
	values.filter((value) => !value.disabledHint).map(({ value }) => value)

const mapSelectOptionCategorizedValues = (values: SelectOptionCategorized[]) =>
	values.flatMap(({ selectOptions }) => mapSelectOptionValues(selectOptions))
